import Vue from 'vue'
import App from './App.vue'
import router from './router';
import VueSession from 'vue-session';
import VueLocalStorage from 'vue-localstorage'
import BootstrapVue from 'bootstrap-vue';
import store from './store'
import Chat from 'vue-beautiful-chat'
import GAuth from 'vue-google-oauth2'



const gauthOption = {
}

const customTokens = {
          bold: {delimiter: '*', tag: 'strong'},
		  italic: {delimiter: '/', tag: 'em'},
		  underline: {delimiter: '_', tag: 'u'},
		  strike: {delimiter: '~', tag: 'del'},
		  code: {delimiter: '`', tag: 'code'},
		  sup: {delimiter: '^', tag: 'sup'},
		  sub: {delimiter: '¡', tag: 'sub'}
    }

var options = {
    persist: true
};

Vue.use(GAuth, gauthOption)
Vue.use(Chat)
Vue.use(BootstrapVue)
Vue.use(VueLocalStorage);
Vue.use(VueSession,options);

Vue.config.productionTip = false;

Vue.component('blog-articles', {
  template: '#my-template',
  props: ['datesArticles'],
  data: function data() {
    return {
      searchQuery: '' };
  },
  computed: {
    searchedArticles: function searchedArticles() {
      var searchRegex = new RegExp(this.searchQuery, 'i');
      var searchedObj = {};
      if (this.searchQuery == '') {
        return this.datesArticles;
      }
      for (var date in this.datesArticles) {
        searchedObj[date] = this.datesArticles[date].filter(function (article) {
          return searchRegex.test(article.title) ||
          searchRegex.test(article.teaser) ||
          searchRegex.test(article.published_at) ||
          searchRegex.test(date);
        });
      }
      return searchedObj;
    } 
  },
  methods: {
    anyArticle: function anyArticle() {
      return this.countAllArticles() ? true : false;
    },
    countAllArticles: function countAllArticles() {
      var count = 0;
      for (var date in this.searchedArticles) {
        count += this.searchedArticles[date].length;
      }
      return count;
    } 
  } 
}); 

new Vue({
  router: router, // inject the router to make whole app router-aware
  store,
  render: h => h(App)
}).$mount("#app");


